import { render, staticRenderFns } from "./object-select.renderer.vue?vue&type=template&id=87c2a79c&"
import script from "./object-select.renderer.vue?vue&type=script&lang=js&"
export * from "./object-select.renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports